import React from "react";
import { useTheme } from "@/context/ThemeContext";
import { Sun, Moon } from "lucide-react";

export default function ThemeToggle() {
  const { theme, toggle } = useTheme();
  return (
    <button data-testid="theme-toggle" onClick={toggle} aria-label="Toggle theme"
      className="h-9 w-9 grid place-items-center rounded-xl border border-border hover:bg-accent transition-colors">
      {theme === "dark" ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
    </button>
  );
}
